import React, { useState, useEffect } from "react"
import dayjs from "dayjs"
import FormikIntervalCalendarField from "../../../components/form/FormikIntervalCalendarField"

const options = ["1 d", "2 d", "3 d", "4 d", "5 d", "6 d", "7 d", "14 d", "1 m", "3 m"].map((day, index) => {
  if (index === 0) return { interval: 1, intervalUnit: "day", intervalDirection: "plus", label: "J+1" }

  const [interval, unit] = day.split(" ")

  if (unit === "m") {
    return {
      label: `J+${interval} mois`,
      interval: parseInt(interval),
      intervalDirection: "plus",
      intervalUnit: interval === "1" ? "month" : "months"
    }
  }

  return {
    label: `J+${interval}`,
    interval: parseInt(interval),
    intervalDirection: "plus",
    intervalUnit: interval === "1" ? "day" : "days"
  }
})

const InternalDLCField = ({ onChange, defaultValue, defaultStartDate, name, formError, maxWidth = "200px" }) => {
  const [value, setValue] = useState(null)
  const [error, setError] = useState(null)
  const [startDate, setStartDate] = useState(null)

  useEffect(() => {
    if (defaultStartDate) {
      setStartDate(defaultStartDate)
      return
    }
    setStartDate(dayjs().valueOf())
  }, [defaultStartDate])

  useEffect(() => {
    if (!defaultValue) return
    setValue(defaultValue)
  }, [defaultValue])

  useEffect(() => {
    if (formError) {
      setError(formError)
      return
    }
    setError(null)
  }, [formError])

  const handleChange = (newValue) => {
    if (!newValue) {
      setError("Invalid date")
    } else {
      setError(null)
    }

    setValue(newValue)

    if (name) {
      onChange(name, newValue)
      return
    }
    onChange(newValue)
  }

  const handleAfterChangeOption = (option) => {
    const selectedOption = { ...option }
    delete selectedOption.date

    let newDate = null
    if (selectedOption.intervalDirection === "plus") {
      newDate = dayjs(startDate).add(selectedOption.interval, selectedOption.intervalUnit)
    } else {
      newDate = dayjs().subtract(selectedOption.interval, selectedOption.intervalUnit)
    }

    const timeStampValue = newDate.valueOf()
    setValue(timeStampValue)

    if (name) {
      onChange(name, timeStampValue)
      return
    }
    onChange(timeStampValue)
  }

  return (
    <FormikIntervalCalendarField
      maxWidth={maxWidth}
      options={options}
      handleChange={handleChange}
      afterChangeOption={handleAfterChangeOption}
      date={value}
      startDate={startDate}
      label="DLC interne"
      hasError={!!error}
      errorText={error}
      popoverSettings={{
        anchorOrigin: { vertical: "bottom", horizontal: "right" },
        transformOrigin: { vertical: "top", horizontal: "right" },
        PaperProps: { sx: { mt: "3px" } }
      }}
    />
  )
}

export default InternalDLCField
